// Chart.js v2 — tooltip HTML externe rendu dans <body>

function getOrCreateEl(chart: any): HTMLDivElement {
  const id = `chartjs-ext-tooltip-${chart.id || chart.chart?.id || '0'}`;
  let el = document.getElementById(id) as HTMLDivElement | null;
  if (!el) {
    el = document.createElement('div');
    el.id = id;
    el.style.position = 'fixed';
    el.style.pointerEvents = 'none';
    el.style.zIndex = '9999';
    el.style.background = '#fff';                 // <-- blanc
    el.style.color = '#111827';                   // texte gris très sombre
    el.style.padding = '8px 10px';
    el.style.borderRadius = '8px';
    el.style.border = '1px solid rgba(0,0,0,.08)'; // léger liseré
    el.style.boxShadow = '0 8px 24px rgba(0,0,0,.12)';
    el.style.font = '12px/1.4 system-ui, -apple-system, Segoe UI, Roboto, Arial';
    el.style.opacity = '0';

    document.body.appendChild(el);
  }
  return el;
}

// ⚠️ NE PAS utiliser une arrow function ici : on a besoin de `this`
export function externalTooltip(this: any, tooltipModel: any) {
  // En v2, le chart est accessible via this._chart
  const chart = this?._chart;
  if (!chart) return;
  console.log('externalTooltip called', tooltipModel.opacity);

  const el = getOrCreateEl(chart);

  // 1) Masquer si pas de tooltip
  if (tooltipModel.opacity === 0) {
    el.style.opacity = '0';
    return;
  }

  // 2) Contenu
  const title = (tooltipModel.title || []).join(' • ');
  const lines: string[] = (tooltipModel.body || [])
    .map((b: any) => b.lines)
    .flat();

  const colors = tooltipModel.labelColors || [];

  el.innerHTML = `
    <div style="font-weight:600;margin-bottom:4px">${title}</div>
    ${lines
      .map((line: string, i: number) => {
        const c = colors[i] || {};
        const box = `<span style="
            display:inline-block;width:10px;height:10px;border-radius:50%;
            margin-right:6px;vertical-align:middle;
            background:${c.backgroundColor || c.borderColor || '#fff'};
            border:1px solid ${c.borderColor || 'transparent'};
          "></span>`;
        return `<div>${box}${line}</div>`;
      })
      .join('')}
  `;

  // 3) Positionner près du caret et borner au viewport
  const rect = chart.canvas.getBoundingClientRect();
  const pageX = rect.left + window.scrollX + (tooltipModel.caretX || 0) + 12;
  const pageY = rect.top  + window.scrollY + (tooltipModel.caretY || 0) + 12;

  // poser d'abord pour obtenir offsetWidth/Height
  el.style.left = `${pageX}px`;
  el.style.top  = `${pageY}px`;
  el.style.opacity = '1';

  const maxX = window.scrollX + window.innerWidth  - el.offsetWidth  - 8;
  const maxY = window.scrollY + window.innerHeight - el.offsetHeight - 8;
  el.style.left = `${Math.min(pageX, maxX)}px`;
  el.style.top  = `${Math.min(pageY, maxY)}px`;
}

export function removeExternalTooltip(chart: any) {
  const id = `chartjs-ext-tooltip-${chart?.id || chart?.chart?.id || '0'}`;
  const el = document.getElementById(id);
  if (el && el.parentNode) el.parentNode.removeChild(el);
}

